const UNITS = ["B", "KB", "MB", "GB", "TB"];

/** A size for people: 1024-based, one decimal from KB up (1,5 GB). */
export function formatBytes(bytes: number, locale = "id-ID"): string {
  let v = Math.max(0, bytes);
  let u = 0;
  while (v >= 1024 && u < UNITS.length - 1) {
    v /= 1024;
    u++;
  }
  const n = new Intl.NumberFormat(locale, { maximumFractionDigits: u === 0 ? 0 : 1 }).format(v);
  return `${n} ${UNITS[u]}`;
}
